import { Controller } from "stimulus"

// data attribute: affiliate-review
export default class extends Controller {
  connect() {
    const rejectButton = document.getElementById("reject-button")
    const rejectForm = document.getElementById("reject-form")
    const buttonsContainer = document.getElementById("buttons-container")
    const cancelButton = document.getElementById("cancel-button")
    if (rejectButton) {
      rejectButton.addEventListener("click", () => this.showRejectForm(rejectForm, buttonsContainer))
    }
    if (cancelButton) {
      cancelButton.addEventListener("click", () => this.hideRejectForm(rejectForm, buttonsContainer))
    }
  }

  showRejectForm(element, buttonsContainer) {
    element.classList.remove("d-none")
    buttonsContainer.classList.add("d-none")
    buttonsContainer.classList.remove("d-flex")
  }
  hideRejectForm(element, buttonsContainer) {
    element.classList.add("d-none")
    buttonsContainer.classList.remove("d-none")
    buttonsContainer.classList.add("d-flex")
  }
}